import axios, { AxiosError } from "axios";
import {
  CreateTenantRequest,
  Tenant,
  UpdateTenantRequest,
} from "../../types/tenant";
import formatAxiosError from "./api-error-handler/apiErrorHandler";
import { AxiosErrorData } from "../../types/axios-errors";

const getAllTenants = async (): Promise<Tenant[]> => {
  try {
    const { data } = await axios.get<Tenant[]>(`/v1/tenants`);
    return data;
  } catch (error) {
    throw formatAxiosError(error as AxiosError<AxiosErrorData>);
  }
};

const createTenant = async (tenant: CreateTenantRequest): Promise<Tenant> => {
  try {
    const { data } = await axios.post<Tenant>(`/v1/tenants`, tenant);
    return data;
  } catch (error) {
    throw formatAxiosError(error as AxiosError<AxiosErrorData>);
  }
};

const updateTenant = async (
  tenantId: string,
  tenant: UpdateTenantRequest
): Promise<Tenant> => {
  try {
    const { data } = await axios.put<Tenant>(`/v1/tenants/${tenantId}`, tenant);
    return data;
  } catch (error) {
    throw formatAxiosError(error as AxiosError<AxiosErrorData>);
  }
};

const deleteTenant = async (tenantId: string): Promise<void> => {
  try {
    await axios.delete<void>(`/v1/tenants/${tenantId}`);
  } catch (error) {
    throw formatAxiosError(error as AxiosError<AxiosErrorData>);
  }
};

const tenantRepository = {
  getAllTenants,
  createTenant,
  updateTenant,
  deleteTenant,
};

export default tenantRepository;
